import { cn } from '@/utils/tailwind.util';
export const Divider = ({
  className
}: {
  className?: string;
}) => {
  return <div className={cn('h-[22px] grow-0 border-x-[0.5px] border-alternative mx-3xs', className)} data-sentry-component="Divider" data-sentry-source-file="Divider.tsx" />;
};